import { gql } from "@apollo/client";

export const  CREATE_PAYMENT_REFUND = gql`
mutation AddRefundPayment($input: createInputData) {
  addRefundPayment(input: $input) {
    status
  }
}
`
export const UPDATE_PAYMENT_STATUS = gql`
mutation UpdateRefundPayment($updateRefundPaymentId: String, $isActive: Boolean) {
  updateRefundPayment(id: $updateRefundPaymentId, isActive: $isActive)
}
`